import { useApiPatch } from 'mf_core/query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useMarkAsReadNotifications() {
  const queryClient = useQueryClient();
  const apiPatch = useApiPatch();

  type MarkAsReadNotificationRequestTo = {
    notificationIds: string[];
    notificationStatus: string;
  };

  return useMutation({
    mutationFn: (body: { notificationIds: string[] }) => {
      const rawValue = body?.notificationIds?.[1];

      const status = ['read', 'delete'].includes(rawValue) ? rawValue : 'read';

      const isBulk =
        body.notificationIds.length > 2 ||
        !['read', 'delete'].includes(rawValue);

      const ids = isBulk ? body.notificationIds : [body.notificationIds[0]];

      const requestObject: MarkAsReadNotificationRequestTo = {
        notificationIds: ids,
        notificationStatus: status,
      };

      return apiPatch(
        '/account-management/v1/notifications/status',
        requestObject
      );
    },
    onError: () => {
      // optional error handler
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          '/account-management/v1/notifications/history?Page=1&Size=10&NotificationType=inapp&onlySummary=true',
        ],
      });
    },
  });
}
